export const solutionList = [
  {
    title: '拓客利器',
    icon: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/header-icon-10.png',
    content: [
      { text: '电子名片', hot: true },
      { text: '电子物料库', hot: true },
      { text: '营销活动', hot: true },
      { text: '发抖音', hot: true },
    ],
    code: '/solution/crm?index=0',
    parentName: 'crm',
    hot: true
  },
  {
    title: 'AI应用',
    icon: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/header-icon-11.png',
    content: [
      { text: 'AI数字人', hot: true },
      { text: 'AI内容创作', hot: true },
      { text: 'AIdee', hot: true },
    ],
    code: '/solution/crm?index=1',
    parentName: 'crm',
    hot: true
  },
  {
    title: '客户管理',
    icon: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/header-icon-12.png',
    content: [
      { text: '跟客助手', hot: true },
      { text: '客户洞察', hot: true },
    ],
    code: '/solution/crm?index=2',
    parentName: 'crm'
  },
  {
    title: '团队协作',
    icon: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/header-icon-13.png',
    content: [
      { text: '招募经纪人', hot: true },
      { text: '经营看板', hot: true },
      { text: '销售排行榜', hot: true },
    ],
    code: '/solution/crm?index=3',
    parentName: 'crm'
  },
  {
    title: '渠道管理',
    icon: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/header-icon-two.png',
    content: [
      { text: '全渠道判客', hot: false },
      { text: '自渠拓客', hot: false },
      { text: '分销管理', hot: false },
      { text: '全民营销', hot: true },
      { text: '快速结佣', hot: true },
      { text: '渠道风控', hot: false },
    ],
    code: '/solution/channel-manage',
    parentName: 'smartField',
    hot: false
  },
  {
    title: '智慧案场',
    icon: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/header-icon-four.png',
    content: [
      { text: '电子签到', hot: false },
      { text: '客户台账', hot: false },
      { text: '智能工牌', hot: true },
      { text: 'GPT盘客', hot: false },
    ],
    code: '/solution/smart-scene',
    parentName: 'smartField',
  },
  {
    title: '交易管理',
    icon: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/header-icon-nine.png',
    content: [
      { text: '在线开盘', hot: false },
      { text: '房源管理', hot: false },
      { text: '回款管理', hot: false },
      { text: '审批管理', hot: false },
    ],
    code: '/solution/transaction-manager',
    parentName: 'smartField',
    hot: true
  },
  {
    title: '营销云',
    icon: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/header-title-cloud.png',
    content: [
      { text: '投放中心', hot: true },
      { text: '内容中心', hot: false },
      { text: '渠道中心', hot: true },
      { text: '数据管理', hot: true },
      { text: '交易管理', hot: false },
    ],
    code: '/solution/marketing-cloud',
    parentName: 'marketCloud',
    hot: true,
  },
  {
    title: '全渠道获客',
    icon: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/header-icon-one.png',
    content: [
      { text: '线上售楼处', hot: false },
      { text: '广告投放', hot: false },
      { text: '营销活动', hot: true },
      { text: '电子物料库', hot: false },
    ],
    code: '/solution/precise-customer',
    parentName: 'marketCloud',
    hot: true,
  },
  {
    title: '社群运营',
    icon: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/header-icon-five.png',
    content: [
      { text: '积分商城', hot: true },
      { text: '会员体系', hot: false },
      { text: '企微运营', hot: false },
    ],
    code: '/solution/customer-precipitate',
    parentName: 'marketCloud',
    hot: true,
  },
  {
    title: '营销自动化',
    icon: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/header-icon-three.png',
    content: [
      { text: '营销自动化', hot: true },
      { text: '客户分析平台', hot: false },
      { text: 'AI云Call', hot: false },
    ],
    code: '/solution/intelligent-operate',
    parentName: 'marketCloud',
    hot: true,
  },
  {
    title: '管理驾驶舱',
    icon: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/header-icon-six.png',
    content: [
      { text: 'BI看板', hot: false },
      { text: '数据报表', hot: false },
    ],
    code: '/solution/data-insight',
    parentName: 'marketCloud',
    hot: true,
  },
  {
    title: '数字沙盘',
    icon: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/header-icon-eight.png',
    content: [
      { text: 'UE5智慧大屏', hot: true, icon: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/header-icon-14.png', },
      { text: 'IPad移动售楼系统', hot: true, icon: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/header-icon-15.png', },
      { text: '微沙盘', hot: true, icon: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/header-icon-eight.png', },
      { text: '云创编辑器', hot: false, icon: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/header-icon-16.png', },
    ],
    code: '/solution/visual-display',
    parentName: 'digitalSandTable',
    direction: 'horizontal'
  },
  {
    title: '品牌展示',
    icon: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/header-icon-community-1.png',
    content: [
      { text: '品牌展示', hot: false },
      { text: '视频看房', hot: true },
    ],
    code: '/solution/community-miniprogram?index=0',
    parentName: 'communityMiniProgram',
    hot: true
  },
  {
    title: '社群活动',
    icon: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/header-icon-community-2.png',
    content: [
      { text: '社群搭子', hot: false },
      { text: '活动中心', hot: true },
    ],
    code: '/solution/community-miniprogram?index=1',
    parentName: 'communityMiniProgram',
    hot: true
  },
  {
    title: '线上商城',
    icon: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/header-icon-community-3.png',
    content: [
      { text: '商城中心', hot: false },
      { text: '优惠券', hot: false },
      { text: '会员积分', hot: true },
    ],
    code: '/solution/community-miniprogram?index=2',
    parentName: 'communityMiniProgram',
    hot: true
  },
  {
    title: '圈层裂变',
    icon: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/header-icon-community-3.png',
    content: [
      { text: '注册合伙人', hot: false },
      { text: '佣金结算', hot: true },
    ],
    code: '/solution/community-miniprogram?index=3',
    parentName: 'communityMiniProgram',
    hot: true
  },

]

export const solutionDefaultSearchList = [
  { text: '销冠CRM', isFirstMenu: true, code: '/solution/crm' },
  { text: '营销云', isFirstMenu: true, code: '/solution/marketing-cloud' },
  { text: '抖音', index: 1, code: '/solution/crm?index=0', parentName: 'crm' },
  { text: '社群运营', isFirstMenu: true, code: '/solution/customer-precipitate' },
  { text: '案场管理', isFirstMenu: true, code: '/solution/smart-scene' },
  { text: 'UE5', index: 0, code: '/solution/visual-display' },
]